import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {INode, INodeItem} from "@Common/widgets/general/tree-extended/node/node.model";


@Injectable()
export class ChecklistDatabase<DataNode> {
  dataChange = new BehaviorSubject<INode<DataNode>[]>([]);
  get data(): INode<DataNode>[] { return this.dataChange.value; }
  private _edit = true;
  set edit(value) {
    this._edit = value;
  }
  constructor() {}

  initialize(tab) {
    const data = this.buildFileTree(tab, 0);
    this.dataChange.next(data);
  }

  private _makeNode(obj, key, value, level, node) {
    if (typeof value === 'object' && value.children !== undefined) {
      node.children = this.buildFileTree(value.children, level + 1);
    }
    return node;
  }
  private _makeConsultNode(obj, key, value, level, node) {
    if (value) {
      return this._makeNode(obj, key, value, level, node);
    }
    return value;
  }
  private _makeEditNode(obj, key, value, level, node) {
    if (value) {
      return this._makeNode(obj, key, value, level, node);
    }
    return value;
  }
  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `INode<DataNode>`.
   */
  buildFileTree(obj: object, level: number): INode<DataNode>[] {
    return Object.keys(obj).reduce<INode<DataNode>[]>((accumulator, key) => {
      const value = obj[key];
      let node = new INode<DataNode>();
      node.item = <INodeItem<DataNode>>{'id': obj[key]['id'], 'data': obj[key]['data']};
      node = this._edit
        ? this._makeEditNode(obj, key, value, level, node)
        : this._makeConsultNode(obj, key, value, level, node);
      if (node) {
        return accumulator.concat(node);
      }
      return accumulator;
    }, []);
  }

  getParentFromNodes(node: INode<DataNode>): INode<DataNode> {
    for (let i = 0; i < this.data.length; ++i) {
      const currentRoot = this.data[i];
      const parent = this.getParent(currentRoot, node);
      if (parent != null) {
        return parent;
      }
    }
    return null;
  }

  getParent(currentRoot: INode<DataNode>, node: INode<DataNode>): INode<DataNode> {
    if (currentRoot.children && currentRoot.children.length > 0) {
      for (let i = 0; i < currentRoot.children.length; ++i) {
        const child = currentRoot.children[i];
        if (child === node) {
          return currentRoot;
        } else if (child.children && child.children.length > 0) {
          const parent = this.getParent(child, node);
          if (parent != null) {
            return parent;
          }
        }
      }
    }
    return null;
  }
}
